module.exports = __webpack_public_path__ + "img/barrage_prize_02.566b1c77.png";